const hideOnPopperBlur = {
  name: 'hideOnPopperBlur',
  defaultValue: true,
  fn(instance,event) {
    return {
      onClickOutside() {
        console.log(instance,event);
        if (
          instance.props.hideOnPopperBlur &&
          event.relatedTarget &&
          !instance.popper.contains(event.relatedTarget)
        ) {
          instance.hide();
        }
        // instance.popper.addEventListener('focusout', (event) => {

        // });
      },
    };
  },
};

const autoMaxWidth = {
  name: 'autoMaxWidth',
  defaultValue: true,
  fn(instance) {
    return {
      onMount() {
        console.log("+++++",instance,event);
      },
    };
  },
};
const booleanProps = {
    a11y: true,
    allowHTML: true,
    animateFill: true,
    arrow: false,
    flip: true,
    flipOnUpdate: false,
    followCursor: false,
    hideOnClick: true,
    ignoreAttributes: false,
    inertia: false,
    interactive: false,
    lazy: true,
    multiple: false,
    showOnInit: false,
    sticky: false,
    touch: true,
    touchHold: false,
    hideOnPopperBlur:true,
    autoMaxWidth:true,
}
export default {
    animation: 'shift-away',
    appendTo: () => document.body,
    aria: 'describedby',
    arrowType: 'sharp',
    boundary: 'scrollParent',
    content: '',
    delay: 0,
    distance: 10,
    duration: [325, 275],
    flipBehavior: 'flip',
    interactiveBorder: 2,
    interactiveDebounce: 0,
    maxWidth: 'none',
    offset: 0,
    onClickOutside(){},
    onHidden() {},
    onHide() {},
    onMount() {},
    onShow() {},
    onShown() {},
    placement: 'top',
    popperOptions: {},
    role: 'tooltip',
    size: 'regular',
    target: '',
    theme: 'light',
    trigger: 'focus',
    updateDuration: 0,
    wait: null,
    zIndex: 2000,
    plugins:[hideOnPopperBlur],
    ...booleanProps,
  }
  
  export {
    booleanProps,
  }


// WEBPACK FOOTER //
// ./src/components/cloud-clinic/components/props.js